<template>
	<div class="box box-search">
		<div class="box box-search-content">
			<div class="scroll" v-bar>
				<div class="scroll-content">
					
					<div class="content">

						<div class="main-title">
							Filtres de recherche
							<div class="clear-filters" v-show="!app.loading" @click="clear_all_filters()" title="Retirer tous les filtres"><icon file="trash-2" /></div>
						</div>

						<div v-show="app.loading" class="loading"><icon file="loader" :size="32" /></div>
						
						<div class="filter name" :class="{ 'has-filter': filter_name }">
							<p class="label">Nom de l'étude</p>
							<div class="input">
								<icon file="search" :size="16" />
								<input type="text" v-model="filter_name" placeholder="Nom de l'étude..." ref="autofocus">
								<div class="empty-input" v-show="filter_name" @click="clear_filter('name')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
						</div>

						<div class="filter location" :class="{ 'has-filter': filter_location }">
							<p class="label">Localisation</p>
							<div class="input">
								<icon file="map-pin" :size="16" />
								<input type="text" v-model="filter_location" placeholder="Ville...">
								<div class="empty-input" v-show="filter_location" @click="clear_filter('location')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
						</div>

						<div class="filter location" :class="{ 'has-filter': filter_departement }">
							<p class="label">Departement</p>
							<div class="input select">
								<icon file="map-pin" :size="16" />
								<select v-model="filter_departement">
									<option value="" selected="selected">Tous les départements</option>
									<option v-for="opt in study.lists.departements" :key="opt.code" :value="opt.code">{{ opt.code }}-{{ opt.label }} </option>
								</select>
								<div class="empty-input" v-show="filter_departement" @click="clear_filter('departement')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
						</div>

						<div class="filter segment" :class="{ 'has-filter': filter_segment }">
							<p class="label">Segment de marché</p>
							<div class="input select">
								<icon file="bar-chart-2" :size="16" />
								<select v-model="filter_segment">
									<option value="" selected="selected">Tous les segments</option>
									<option v-for="opt in study.lists.segments" :key="opt.code" :value="opt">
										{{ opt.code }} - {{ opt.nom }}
									</option>
								</select>
								<div class="empty-input" v-show="filter_segment" @click="clear_filter('segment')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
						</div>
						
						<div class="row">
							<div class="col half">
								<div class="filter status" :class="{ 'has-filter': filter_status }">
									<p class="label">Statut</p>
									<div class="input select">
										<icon file="bookmark" :size="16" />
										<select v-model="filter_status">
											<option value="">Tous</option>
											<option v-for="opt in study.lists.statuts" :value="opt" :key="opt.slug">{{ opt.nom }}</option>
										</select>
										<div class="empty-input" v-show="filter_status" @click="clear_filter('status')" title="Vider le champ"><icon file="x" :size="24" /></div>
									</div>
								</div>
							</div>
							<div class="col half">
								<div class="filter year" :class="{ 'has-filter': filter_year_creation }">
									<p class="label">Année</p>
									<div class="input select">
										<icon file="calendar" :size="16" />
										<select v-model="filter_year_creation">
											<option value="">Toutes</option>
											<option v-for="opt in study.lists.years" :key="opt.year" :value="opt.year">{{ opt.year }}</option>
										</select>
										<div class="empty-input" v-show="filter_year_creation" @click="clear_filter('year_creation')" title="Vider le champ"><icon file="x" :size="24" /></div>
									</div>
								</div>
							</div>
						</div>

						<div  class="filter consultant" :class="{ 'has-filter': filter_contributeur }">
							<p class="label">Collaborateurs ADEQUATION</p>
							<div class="input select">
								<icon file="user" :size="16" />
								<select v-model="filter_contributeur" @click="clear_filter('contributeur_current')">
									<option value="" selected="selected">Tous les contributeurs</option>
									<option v-for="opt in study.lists.contributeurs" :key="opt.id" :value="opt">{{ opt.nom_complet }}</option>
									<!-- <option v-for="user in study.lists.users" :key="user.id" v-if="user.AD" :value="user">{{ user.prenom }} {{ user.nom }}</option> -->
								</select>
								<div class="empty-input" v-show="filter_contributeur" @click="clear_filter('contributeur')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
							<div class="input">
								<icon file="user" :size="16" />
								<input type="text" v-model="filter_contributeur_email" placeholder="p.nom@adequation...">
								<div class="empty-input" v-show="filter_contributeur_email" @click="clear_filter('contributeur_email')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
							<input type="checkbox" v-model="filter_contributeur_current" @click="clear_filter('contributeur')"/><span class="cb-label"> Mes études</span>
						</div>

						<div class="filter evalis" :class="{ 'has-filter': filter_evalis }">
							<p class="label">Evalis</p>
							<div class="input select">
								<icon file="filter" :size="16" />
								<select v-model="filter_evalis" disabled>
									<option value="">Toutes</option>
									<option v-for="opt in study.lists.code_evalis_list" :key="opt.code_evalis" :value="opt.code_evalis">{{ opt.code_evalis }}</option>
								</select>
								<div class="empty-input" v-show="filter_evalis" @click="clear_filter('code_evalis')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
							<div class="input">
								<icon file="filter" :size="16" />
								<input type="text" v-model="filter_evalis" placeholder="RefEvalis..."  @click="clear_filter('code_evalis_empty')" />
								<div class="empty-input" v-show="filter_evalis" @click="clear_filter('code_evalis')" title="Vider le champ"><icon file="x" :size="24" /></div>
							</div>
							<input type="checkbox" v-model="filter_evalis_empty" @click="clear_filter('code_evalis') "/><span class="cb-label"> Sans référence Evalis</span>
						</div>
					
					</div>

				</div>
			</div>
		</div>
		<div class="main-button"   :class="{ 'search-disable': !search_available }" @click="search_available ? search_projects() : null"><icon file="search" :size="24" />Rechercher</div>
		<div v-show="app.loading" class="loading-layer"></div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
	name: "search",
	data: function () {
		return {
			filter_contributeur_logged : false,
			search_available : false
		};
	},
	computed: {
		...mapGetters([ "app", "study", "search","user" ]),
		adequation_users () {
			return _.filter(this.study.lists.users, "AD", true);
		},
		filter_name: {
			get: function () { return this.search.filters.name; },
			set: function (value) { this.setter("name", value); }
		},
		filter_location: {
			get: function () { return this.search.filters.location; },
			set: function (value) { this.setter("location", value); }
		},
		filter_evalis: {
			get: function () { return this.search.filters.code_evalis; },
			set: function (value) { this.setter("code_evalis", value); }
		},
		filter_departement: {
			get: function () { return this.search.filters.departement; },
			set: function (value) { this.setter("departement", value); }
		},
		filter_segment: {
			get: function () { return this.search.filters.segment; },
			set: function (value) { this.setter("segment", value); }
		},
		filter_segment_not: {
			get: function () { return this.search.filters.segment_not; },
			set: function (value) { this.setter("segment_not", value); }
		},
		filter_type: {
			get: function () { return this.search.filters.type; },
			set: function (value) { this.setter("type", value); }
		},
		filter_status: {
			get: function () { return this.search.filters.status; },
			set: function (value) { this.setter("status", value); }
		},
		filter_year_creation: {
			get: function () { return this.search.filters.yearCreation; },
			set: function (value) { this.setter("yearCreation", value); }
		},
		filter_contributeur: {
			get: function () { return this.search.filters.contributeur; },
			set: function (value) { this.setter("contributeur", value); }
		},
		filter_contributeur_email: {
			get: function () { return this.search.filters.contributeur_email; },
			set: function (value) { this.setter("contributeur_email", value); }
		},
		filter_contributeur_current: {
			get: function () { return this.search.filters.contributeur_current; },
			set: function (value) { this.setter("contributeur_current", value); }
		},
		filter_evalis_empty: {
			get: function () { return this.search.filters.code_evalis_empty; },
			set: function (value) { this.setter("code_evalis_empty", value); }
		}
	},
	methods: {
		setter: _.debounce(function (filter, value) {
			this.search_available = true;
			const o = {};
			o[filter] = value;
			this.$store.dispatch("set_filter", o);
		}, 300),
		clear_filter: function (filter,clear_value="") {
			this.search_available = true;
			const o = {};
			o[filter] = clear_value;
			this.$store.dispatch("set_filter", o);
		},
		clear_all_filters: function () {
			const filters = {};
			for (const i in this.search.filters) {
				filters[i] = "";
			}
			this.$store.dispatch("set_filter", filters);
			this.search_projects()
		},
		search_projects: function () {
			this.search_available = false;
			this.$store.dispatch("search_projects");
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			this.$refs.autofocus.focus();
		});
		this.$store.dispatch("init_facets");
	}
};
</script>


<style lang="stylus" scoped>
@import '../../assets/css/app'
@import '../../assets/css/grid'
@import '../../assets/css/box'
@import '../../assets/css/ui'

.box
	position absolute
	left 0
	top 0
	right -8px
	bottom 0
	background-color darken(gray, 25%)
	transform translate(-16px, 12px)
	border-top-left-radius 0
	border-bottom-left-radius 0
	color #ccc
	z-index 1
	height calc(100% - 24px)
	overflow visible
	.box-search-content
		height calc(100% - 64px)
		// background red
		transform translateX(0px)
	.scroll, .scroll-content
		height 100%
	.content
		height auto
		padding 24px 24px 24px 24px

		
.main-title
	margin 0 0 16px 0
	color #fff
	font-weight 500
	font-size 1.8rem
	line-height 24px

.clear-filters
	position absolute
	right 0
	top 0
	opacity 0.5
	cursor pointer
	&:hover
		opacity 1
	
.loading
	position absolute
	right 20px
	top 20px
	animation rotate 3s infinite easeOutQuart

@keyframes rotate
	from
		transform rotate(0deg)
	to
		transform rotate(359deg)

.filter
	:disabled
		background-color black
	margin 0 0 16px 0
	&.has-filter
		.input
			background-image none
			select
				color dark
	.label
		display block
		margin 0 0 2px 0
	.input
		color dark
		height 40px
		line-height @height
		outline none
	input, select
		outline none
	select
		cursor default
		color #999
		option
			color dark
			&:first-child
				color #999
	.hint
		font-size 1.2rem
		line-height 16px
	.empty-input
		position absolute
		right 8px
		top 0
		color dark
		cursor pointer
		// background-color #f5f5f5
		&:hover
			color red


.separator
	height 1px
	margin 24px 0
	background darken(gray, 10%)

.checkboxes
	.item
		display block
		margin 0 0 8px 0
		cursor pointer
		line-height 24px
		&:hover
			.input.checkbox
				background-color #ddd
		.input.checkbox
			float left
			width 24px
			height 24px
			margin 0 8px 0 0
			cursor pointer
			&.checked
				.icon
					display block
			input
				display none
				position absolute
				left 110%
				top 0
				opacity 0.5
			.icon
				display none
				position absolute
				left 50%
				top 50%
				transform translate(-50%, -50%)


.main-button
	position absolute
	width calc(100% + 8px)
	right -8px
	left 0
	bottom 0
	border-radius 0
	border-bottom-right-radius radius
.search-disable
	opacity	0.3
	cursor not-allowed
.loading-layer
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	background alpha(dark, 25%)
	z-index 1

@media screen and (max-width: 800px)
	
	.map-filter
		display none
	
	.col.half
		margin-bottom 16px

</style>